// src/pages/Jobs.js
import React, { useState } from "react";
import { Briefcase, CheckCircle } from "lucide-react";
import MyJobs from "./MyJobs";
import AppliedJobs from "./AppliedJobs";

const Jobs = () => {
  const [activeTab, setActiveTab] = useState("my-jobs");

  const renderContent = () => {
    switch (activeTab) {
      case "applied-jobs":
        return <AppliedJobs />;
      default:
        return <MyJobs />;
    }
  };

  return (
    <div className="w-full min-h-screen flex flex-col bg-gray-50">
      {/* HEADER */}
      <div className="p-4 pt-6 md:pt-10 text-center border-b border-gray-200 bg-white shadow-sm">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
          {activeTab === "my-jobs" ? "My Jobs" : "Applied Jobs"}
        </h1>
        <p className="text-gray-500 mt-1 text-sm">
          {activeTab === "my-jobs"
            ? "Jobs you’ve accepted or completed"
            : "Jobs you’ve applied for and awaiting approval"}
        </p>
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-1 overflow-y-auto px-4 py-6 md:pb-32">
        {renderContent()}
      </div>

      {/* ✅ BOTTOM NAVBAR TOGGLE (replaces MobileNavbar) */}
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] flex justify-around items-center py-2 md:py-3">
        <button
          onClick={() => setActiveTab("my-jobs")}
          className={`flex flex-col items-center text-sm font-medium transition ${
            activeTab === "my-jobs" ? "text-blue-600" : "text-gray-500"
          }`}
        >
          <Briefcase
            size={22}
            className={activeTab === "my-jobs" ? "text-blue-600" : ""}
          />
          <span className="text-[12px] mt-0.5">My Jobs</span>
        </button>

        <button
          onClick={() => setActiveTab("applied-jobs")}
          className={`flex flex-col items-center text-sm font-medium transition ${
            activeTab === "applied-jobs" ? "text-blue-600" : "text-gray-500"
          }`}
        >
          <CheckCircle
            size={22}
            className={activeTab === "applied-jobs" ? "text-blue-600" : ""}
          />
          <span className="text-[12px] mt-0.5">Applied Jobs</span>
        </button>
      </div>
    </div>
  );
};

export default Jobs;

